import AnimateNumber from './AnimateNumber'

export type * from './AnimateNumber'
export default AnimateNumber
